import React from 'react'
import { Grid, Typography, Box, Button, Link } from '@mui/material'
import { grey } from '@mui/material/colors'
import { AccountCircle, Search, Home } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router-dom'

import { KEYCLOAK_ROLES } from 'helpers/constants'
import RenderOnRole from 'components/access/RenderOnRole'
import usePageView from 'hooks/usePageView'

function Landing() {
  usePageView()
  const { t } = useTranslation()
  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item container xs={12} md={6}>
          <Grid
            item
            sx={{
              width: '100%',
              border: '1px solid',
              borderColor: grey[300],
              boxShadow: 25,
              borderRadius: '9px',
              mt: { xs: '56px', md: '10px' },
              p: '48px',
              bgcolor: 'background.paper',
            }}
          >
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  variant="h5"
                  sx={{ alignItems: 'center', display: 'flex' }}
                >
                  <AccountCircle color="primary" sx={{ fontSize: 30, mr: 2 }} />{' '}
                  {t('dashboard.pages.landing.updateProfileCard.title')}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Link component={RouterLink} to="/profile" underline="none">
                  <Button
                    variant="contained"
                    sx={{ width: '100%', textTransform: 'none', mt: 5 }}
                  >
                    {t(
                      'dashboard.pages.landing.updateProfileCard.updateButton'
                    )}
                  </Button>
                </Link>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item container xs={12} md={6}>
          <Grid
            item
            sx={{
              width: '100%',
              border: '1px solid',
              borderColor: grey[300],
              boxShadow: 25,
              borderRadius: '9px',
              mt: { xs: '40px', md: '10px' },
              p: '48px',
              bgcolor: 'background.paper',
            }}
          >
            <Grid item container>
              <Grid item xs={12}>
                <Typography
                  variant="h5"
                  sx={{ alignItems: 'center', display: 'flex' }}
                >
                  <Search color="primary" sx={{ fontSize: 30, mr: 2 }} />{' '}
                  {t('dashboard.pages.landing.recentSearchCard.title')}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Link
                  href={
                    process.env.REACT_APP_REDIRECT_SEARCH_APP_URL + 'recent'
                  }
                  underline="none"
                  target="_blank"
                >
                  <Button
                    variant="contained"
                    sx={{ width: '100%', textTransform: 'none', mt: 5 }}
                  >
                    {t(
                      'dashboard.pages.landing.recentSearchCard.forMoreButton'
                    )}
                  </Button>
                </Link>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <RenderOnRole roles={[KEYCLOAK_ROLES.ROLE_AGENT]}>
          <Grid item container xs={12} md={6}>
            <Grid
              item
              sx={{
                width: '100%',
                border: 1,
                borderColor: grey[300],
                boxShadow: 25,
                borderRadius: 2.5,
                mt: 5,
                p: 6,
                bgcolor: 'background.paper',
              }}
            >
              <Grid item container>
                <Grid item xs={12}>
                  <Typography
                    variant="h5"
                    sx={{ alignItems: 'center', display: 'flex' }}
                  >
                    <Home color="primary" sx={{ fontSize: 30, mr: 2 }} />{' '}
                    {t('dashboard.pages.landing.myPropertyAds.title')}
                  </Typography>
                </Grid>
                <Grid item xs={12} sx={{ mt: 5 }}>
                  <Grid
                    item
                    container
                    display="flex"
                    justifyContent="center"
                    spacing={3}
                  >
                    <Grid item>
                      <Link
                        component={RouterLink}
                        to="/my-property-ads"
                        underline="none"
                      >
                        <Button
                          variant="contained"
                          sx={{ textTransform: 'none' }}
                        >
                          {t(
                            'dashboard.pages.landing.myPropertyAds.moreInformationButton'
                          )}
                        </Button>
                      </Link>
                    </Grid>
                    <Grid item>
                      <Link component={RouterLink} to="/property-ads/create">
                        <Button
                          variant="contained"
                          sx={{ textTransform: 'none' }}
                        >
                          {t(
                            'dashboard.pages.landing.myPropertyAds.insertButton'
                          )}
                        </Button>
                      </Link>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </RenderOnRole>
      </Grid>
    </Box>
  )
}

export default Landing
